<template>
  <div class="body">
    <!-- 使用 TopNav 组件 -->
    <TopNav />

    <!-- 页面内容 -->
    <div class="page">
      <div class="img"><img src="@/assets/big.a327fb7f.png" alt=""></div>
     <div class="page1">
      <div class="page2">
        <div class="mode">
          <div class="mode1">
            <div class="modetitle">
              <div class="gang"></div>
              <span>公司简介</span>
              <div class="gang"></div>
            </div>
            <div class="modepage" @click="navigateTo('/introduce')">
              <div class="modeimg">
                <img src="@/assets/gongsidamen.jpg" alt="">
              </div>
              <div class="jianjie">
                <p>湖北江城子建材科技有限公司是一家专业从事聚羧酸系减水剂、混凝土膨胀剂、玻化微珠保温
                  隔热砂浆产品的研发、生产、销售及技术服务的高新技术企业。目前公司已形成年产 3 万吨聚羧
                  酸系减水剂、5 万吨玻化微珠保温砂浆、2 万吨混凝土膨胀剂及特种干混砂浆的生产规模。
                  公司现有职工 150 余人，其中研发及工程技术人员 30 名。公司与国内外著名高校和科研院所建立
                  了产、学、研合作关系，聘请了省内外一批知名专家、教授和专业人士组成专业科研团队，对产品
                  研发进行指导，对高性能聚羧酸系减水剂、混凝土膨胀剂、玻化微珠保温隔热砂浆产品、特种干混
                  砂浆等建筑、工程材料开展了大量研究，为满足客户建设需要、提高产品质量提供了技术保障。
                  公司坚持“诚信立足，创新致远”的企业文化理念，狠抓产品质量和技术服务。系列产品已广泛应
                  用于铁路、公路、水利、市政、桥梁、工业与民用建筑各领域，起到了改善工作性能、提高工程质
                  量、节能环保、可持续发展的良好作用。
                  公司秉承科学发展理念，将与广大客户一起共同实现“中国梦”而不懈努力！</p>
                <div class="stats">
                  <div class="stat-item">
                    <div class="stat-value">2013年</div>
                    <div class="stat-label">公司成立于</div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-value">50+个</div>
                    <div class="stat-label">国家基建项目</div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-value">14项+</div>
                    <div class="stat-label">科技进步奖项</div>
                  </div>
                  <div class="stat-item">
                    <div class="stat-value">51项+</div>
                    <div class="stat-label">国家专利</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mode">
          <div class="mode1">
            <div class="modetitle">
              <div class="gang"></div>
              <span>代表工程</span>
              <div class="gang"></div>
            </div>
            <div class="modepage" style="background-color: transparent;">
              <div class="modepage1">
                <div class="sidebar">
                  <div class="sidebar-item" @click="selectProject('咸九高速')">公路工程</div>
                  <div class="sidebar-item" @click="selectProject('松枝长江大桥')">桥隧工程</div>
                  <div class="sidebar-item" @click="selectProject('武汉天河机场')">空港工程</div>
                  <div class="sidebar-item" @click="selectProject('深圳地铁13号线')">市政工程</div>
                  <div class="sidebar-item" @click="selectProject('燕矶长江大桥')">桥隧工程</div>
                  <div class="sidebar-item" @click="selectProject('鄂州花湖机场')">空港工程</div>
                </div>
                <div class="project-display">
                  <img :src="selectedProjectImage" alt="Selected Project">
                  <div class="project-name">{{ selectedName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mode">
          <div class="mode1">
            <div class="modetitle">
              <div class="gang"></div>
              <span>企业证书</span>
              <div class="gang"></div>
            </div>
            <div class="modepage" >
              <ImgCarousel></ImgCarousel>
            </div>
          </div>
        </div>
       </div>
     </div>
      <div>
        <FootIndex></FootIndex>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue' // 引入 TopNav 组件
import FootIndex from '@/components/FootIndex.vue'
import ImgCarousel from '@/components/ImgCarousel.vue'

export default {
  name: 'HomeIndex',
  components: {
    TopNav,
    FootIndex,
    ImgCarousel
  },
  data () {
    return {
      selectedProject: '咸九高速',
      selectedName: '咸九高速',
      projects: {
        咸九高速: require('@/assets/代表工程/咸九高速.jpeg'),
        松枝长江大桥: require('@/assets/代表工程/松枝长江大桥.jpeg'),
        武汉天河机场: require('@/assets/代表工程/武汉天河机场.jpeg'),
        深圳地铁13号线: require('@/assets/代表工程/深圳地铁13号线.jpeg'),
        燕矶长江大桥: require('@/assets/代表工程/燕矶长江大桥.jpeg'),
        鄂州花湖机场: require('@/assets/代表工程/鄂州花湖机场.jpeg')
      }
    }
  },
  computed: {
    selectedProjectImage () {
      return this.projects[this.selectedProject]
    }
  },
  methods: {
    navigateTo (path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
      this.closeNav()
    },
    selectProject (project) {
      this.selectedProject = project
      this.selectedName = project
    }
  }
}
</script>

<style lang="less" scoped>
.body {
  display: grid;
  grid-template-rows: 66px auto; /* 第一行是 nav 的高度，第二行是剩余空间 */
  height: 100vh;
  color: #000;
}

.page {
  padding-top: 100px;
}

.page1{
  display: flex;
  align-items: center;
  justify-content: center;
}

.page2{
  width: 100%;
}

.img {
  width: 100%;
  min-width: 1000px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.img img{
  width: 100%;
  min-width: 1200px;
}

.modetitle {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
}

.modetitle span {
  font-size: 30px;
    padding-top: 0px;
    font-weight: bold;
    font-family: SimSun;
  color: #000;
  margin: 0 6px 0px 6px;
}

.gang {
  display: block;
  background: rgb(198, 198, 198);
  width: 1rem;
  height: 0.062rem;
  border-radius: inherit;
}

.modepage {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(220, 220, 220);
  padding: 20px;
}

.modepage1{
  height: 500px;
  width: 1200px;
  display: flex;
}

.modeimg {
  width: 40%;
  height: auto;
  overflow: hidden;
  border-radius: 20px;
}

.modeimg img {
  width: 100%;
  height: auto;
}

.jianjie {
  width: 55%;
  text-indent: 2em;
  margin-left: 20px;
}

.jianjie p {
  font-size: 16px;
  line-height: 2;
}

.stats {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #004da0;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

.sidebar {
  width: 25%;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 垂直居中 */
  align-items: center; /* 水平居中 */
  height: 100%; /* 确保 .sidebar 占满父容器的高度 */
}

.sidebar-item {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%; /* 设置宽度，使其居中 */
  height: 75px;
  background-color: #f0f0f0;
  cursor: pointer;
  text-align: center;
  margin-bottom: 1px;
}

.sidebar-item:hover {
  background-color: #ddd;
}

.project-display {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 75%;
  height: 100%;
  overflow: hidden;
  position: relative; /* 添加相对定位 */
}

.project-display img {
  width: 100%;
  height: 500px;
  border-radius: 10px;
  position: relative;
}

.project-name{
  position: absolute;
  bottom: 0px; /* 放置在底部 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(0, 0, 0, 0.5); /* 背景色 */
  color: white; /* 文字颜色 */
  padding: 20px 0px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
  z-index: 1;
  width: 100%;
}
</style>
